import { useState } from "react";
const useLoadingState = ()=>{
    const [isLoading, setLoadingStatus] = useState(false);
    const [retrievalLoading, setRetrievalLoading] = useState(false);
    const [loadingStatusMessages, setLoadingStatusMessage] = useState([]);
    const [loadingHotelSkeleton, setLoadingHotelSkeleton] = useState(false);
    return {
        isLoading,
        setLoadingStatus,
        retrievalLoading,
        setRetrievalLoading,
        loadingStatusMessages,
        setLoadingStatusMessage,
        loadingHotelSkeleton,
        setLoadingHotelSkeleton
    };
};
export { useLoadingState };
